import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, CircularProgress, GlobalStyles } from '@mui/material';
import { themeOptions } from './themes/themes';
import { RouterProvider } from 'react-router-dom';
import { router } from './Routes';
import { AlertProvider, DatastoreProvider, IsOnlineProvider, LoadingProvider, UserLoginProvider } from './hooks';
import { ServiceWorkerUpdate, SyncSuccessToast, SyncBlocker } from './components';

function AppContent() {
  return (
    <>
      <SyncSuccessToast />
      <ServiceWorkerUpdate>
        <LoadingProvider>
          <UserLoginProvider>
            <DatastoreProvider>
              <SyncBlocker>
                <AlertProvider>
                  <RouterProvider router={router} fallbackElement={<CircularProgress />} />
                </AlertProvider>
              </SyncBlocker>
            </DatastoreProvider>
          </UserLoginProvider>
        </LoadingProvider>
      </ServiceWorkerUpdate>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={themeOptions}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            overscrollBehavior: 'none'
          },
          html: {
            overscrollBehavior: 'none'
          }
        }}
      />
      <IsOnlineProvider>
        <AppContent />
      </IsOnlineProvider>
    </ThemeProvider>
  );
}

export default App;
